"use strict";

exports.__esModule = true;
exports.default = void 0;
const tooltipPadding = ({
  contentHeight,
  theme
}) => {
  // one-line text should have smaller top/bottom padding
  if (contentHeight <= Math.floor(parseFloat(theme.orbit.lineHeightTextNormal))) {
    return `${theme.orbit.spaceXSmall} ${theme.orbit.spaceSmall}`;
  }
  return theme.orbit.spaceSmall;
};
var _default = tooltipPadding;
exports.default = _default;